import { createTheme } from '@mui/material/styles'

const defaultTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#00e676',
      contrastText: '#000000', // Добавляем черный цвет для текста на primary элементах
    },
    secondary: {
      main: '#001339',
    },
    success: {
      main: '#00ff0a',
    },
    text: {
      primary: '#000000', // Это установит черный цвет для основного текста
    },
  },
})

export default defaultTheme
